export const tenantData = [
  {
    value:
      "Alexander Truoccolo - 9723 NE 3rd Pl - 9723 NE 3rd Pl Midwest City, OK 73130",
    label:
      "Alexander Truoccolo - 9723 NE 3rd Pl - 9723 NE 3rd Pl Midwest City, OK 73130",
    AvailableCreditsOrPrepayments: [
      {
        glAccount: "118: Prepayments",
        date: "02/01/2023",
        description: "Online Payment",
        balance: 469.0,
      },
      {
        glAccount: "112: Prepayments",
        date: "02/01/2023",
        description: "Online Payment",
        balance: 469.0,
      },
    ],
    UnpaidCharges: [],
  },
  {
    value: "Aamir Khan (Eagle) - test1 - 912 n creek dr  edmond, OK 73034",
    label: "Aamir Khan (Eagle) - test1 - 912 n creek dr  edmond, OK 73034",
    AvailableCreditsOrPrepayments: [],
    UnpaidCharges: [],
  },
  {
    value:
      "Angela S. Lamka-West - 9626 SE 4th - 9626 SE 4th  Midwest City, OK 73130",
    label:
      "Angela S. Lamka-West - 9626 SE 4th - 9626 SE 4th  Midwest City, OK 73130",
    AvailableCreditsOrPrepayments: [],
    UnpaidCharges: [
      {
        glAccount: "997: Eviction Notice Fee",
        date: "02/13/2023",
        description: "eviction notice fee",
        balance: 35.0,
      },
      {
        glAccount: "103: Rent Income",
        date: "02/01/2023",
        description: "February 2023",
        balance: 632.0,
      },
      {
        glAccount: "108: Late Fee Income",
        date: "02/04/2023",
        description: "Late Fee for Feb 2023",
        balance: 77.50,
      },
      {
        glAccount: "23280: Legal and Professional Fees",
        date: "02/02/2023",
        description: "",
        balance: 200.00,
      },
    ],
  },
];
